// Theme Registry - Maps theme names to their components
import { lazy } from 'react';

// Lazy load themes for better performance
const ThrowballLayout = lazy(() => import('./throwball/ThrowballLayout'));
const ThrowballHomepage = lazy(() => import('./throwball/ThrowballHomepage'));

// Theme configuration registry - Only Throwball theme
export const THEMES = {
  throwball: {
    name: 'Throwball',
    description: 'Throwball Federation Theme',
    Layout: ThrowballLayout,
    Homepage: ThrowballHomepage,
    preview: '/images/themes/throwball-preview.png'
  }
};

// Get theme configuration by name - returns throwball as default
export const getTheme = (themeName) => {
  return THEMES[themeName] || THEMES.throwball;
};

// Get all available themes for admin selection
export const getAvailableThemes = () => {
  return Object.entries(THEMES).map(([key, value]) => ({
    id: key,
    name: value.name,
    description: value.description,
    preview: value.preview
  }));
};

export default THEMES;
